<template>
  <div>
    <div class="field">
      <label class="label">{{ $t("service url") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.service_url"
          placeholder="https://impulsatapp.ucontactcloud.com/Integra/resources/SMS/SendSMS"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-server"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("campaign") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.campaign"
          placeholder="Formalizaciones"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-building"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("agent") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.agent"
          placeholder="Formalizaciones"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("origin") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.origin"
          placeholder="1"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-key"></i>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
    clear() {
      this.meta = {
        service_url: "",
        campaign: "",
        agent: "",
        origin: "",
      };
    },
  },
};
</script>
